import { atom, createStore } from 'jotai';

export const sidebarItemsAtom = atom<string[]>([]);
export const atoms = createStore();

export const selectedModuleOverview = atom<string>('Real Estate (RE)');
